import { render, staticRenderFns } from "./StockChargeOffList.vue?vue&type=template&id=37855b3f&"
import script from "./StockChargeOffList.vue?vue&type=script&lang=ts&"
export * from "./StockChargeOffList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports